import Cookies from 'js-cookie';

export const isToolsPage = () => {
    return (
        window.location.hostname.includes('tools') ||
        Cookies.get('isTools') === 'true' ||
        (process.env.VITE_ENV_TYPE === 'LOCAL' &&
            new URLSearchParams(window.location.search).get('tools'))
    );
};
